class ComponentDrawer extends HTMLElement {
  constructor() {
    super()

    this.drawerId = this.id
    this.overlay = this.querySelector('[data-drawer-overlay]')
    this.drawerClose = this.querySelectorAll('[data-drawer-close]')
    this.html = document.querySelector('html')

    this.focusableElements =
      'button, a, input, textarea, select, details, summary, [tabindex]:not([tabindex="-1"])'
  }

  connectedCallback() {
    document.addEventListener('click', this.handleTriggerClick.bind(this))
    this.overlay?.addEventListener('click', this.handleOverlayClick.bind(this))
    this.drawerClose?.forEach((btn) =>
      btn.addEventListener('click', this.handleCloseClick.bind(this))
    )
    document.addEventListener('keydown', this.handleEscapeKey.bind(this))
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleTriggerClick)
    this.overlay?.removeEventListener('click', this.handleOverlayClick)
    this.drawerClose?.removeEventListener('click', this.handleCloseClick)
    document.removeEventListener('keydown', this.handleEscapeKey)
  }

  openDrawer() {
    this.setAttribute('open', '')
    this.removeAttribute('inert')
    this.setAttribute('aria-expanded', 'true')
    this.addTrapFocus()
    this.html.classList.add('drawer-open-html')
    if (!this.getAttribute('data-enable-scroll'))
      __THEME_GLOBALS__.disableScroll()
  }

  closeDrawer() {
    this.removeAttribute('open')
    this.setAttribute('inert', '')
    this.setAttribute('aria-expanded', 'false')
    this.removeTrapFocus()
    this.html.classList.remove('drawer-open-html')
    if (!this.getAttribute('data-enable-scroll'))
      __THEME_GLOBALS__.enableScroll()
  }

  handleTriggerClick(e) {
    const closestButton = e.target.closest(
      '[data-drawer-close],[data-drawer-target],button,[data-drawer-overlay]'
    )
    if (closestButton?.getAttribute('data-drawer-target') === this.drawerId) {
      this.openDrawer()
    }
    if (
      closestButton?.getAttribute('data-close-drawer-target') === this.drawerId
    ) {
      this.closeDrawer()
    }
  }

  handleOverlayClick() {
    this.closeDrawer()
  }

  handleCloseClick() {
    this.closeDrawer()
  }

  handleEscapeKey(e) {
    if (!this.hasAttribute('open')) return
    if (e.key !== 'Escape') return

    this.closeDrawer()
  }

  addTrapFocus() {
    this.previousActiveElement = document.activeElement

    this.focusableEls = Array.from(
      this.querySelectorAll(this.focusableElements)
    )

    this.firstFocusableEl = this.focusableEls[0]
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1]

    this.focusableEls.forEach((el) => {
      el.addEventListener('keydown', this.handleFocusTrap.bind(this))
    })

    this.firstFocusableEl?.focus({
      preventScroll: true,
    })
  }

  removeTrapFocus() {
    this.focusableEls?.forEach((el) => {
      el.removeEventListener('keydown', this.handleFocusTrap)
    })

    this.previousActiveElement?.focus({
      preventScroll: true,
    })
  }

  handleFocusTrap(e) {
    if (e.key !== 'Tab') return

    const firstFocusableEl = this.firstFocusableEl
    const lastFocusableEl = this.lastFocusableEl
    const isTabForward = !e.shiftKey
    const isTabBackward = e.shiftKey

    const isFirstElement = document.activeElement === firstFocusableEl
    const isLastElement = document.activeElement === lastFocusableEl

    if ((isTabBackward && isFirstElement) || (isTabForward && isLastElement)) {
      e.preventDefault()
      isTabBackward ? lastFocusableEl.focus() : firstFocusableEl.focus()
    }
  }
}

customElements.define('component-drawer', ComponentDrawer)
